module.exports = __webpack_public_path__ + "static/media/avatar_poodle.e31be7c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_poodle.png
// module id = 395
// module chunks = 0